<mat-card class="calendar-card">
  <div class="header">
    <div class="circle" (click)="moveBack()">
      <i class="fa-solid fa-backward-step"></i>
    </div>
    <div class="header-text">{{ monthName }}</div>
    <div class="circle" [class.disabled]="nextMonthDisabled" (click)="moveForward()">
      <i class="fa-solid fa-forward-step"></i>
    </div>
  </div>
  <mat-calendar
    #calendar
    [(selected)]="selected"
    [dateFilter]="dateFilter"
    [dateClass]="dateClass"
    (selectedChange)="onDateSelected($event)"
  ></mat-calendar>
</mat-card>